import styled from 'styled-components'

import { NATIVE_BASE_COLORS, COLOR, FONT_SIZE } from '../../themes'
import { colorThemeSelector } from '../../helpers'

export const StyleCrashMeetingModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 23px 20px 33px;
  border-bottom: 1px solid ${NATIVE_BASE_COLORS.TEXT[200]};

  .crash-meeting-modal {
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
    font-family: NunitoSansBold;
    font-size: ${FONT_SIZE.SM};
  }
`

export const StyleCrashMeetingModalContent = styled.div`
  padding: 20px 23px 20px 33px;
  border-bottom: 1px solid ${NATIVE_BASE_COLORS.TEXT[200]};

  .description {
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.XS};
    color: ${NATIVE_BASE_COLORS.TEXT[800]};
  }
`

export const StyleCrashMeetingModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 23px 20px 33px;

  .submit-button {
    display: flex;
    width: 100%;
    height: 48px;
    padding: 10px 12px;
    justify-content: center;
    background-color: ${NATIVE_BASE_COLORS.PRIMARY[200]};
    outline: none;
    border: 0px;
    border-radius: 4px;
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.SM};
    cursor: pointer;
  }

  .change-date-button {
    width: 170px;
    height: auto;
    padding: 10px 12px;
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    border-radius: 4px;
    background-color: transparent;
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.XS};
    color: ${COLOR.BLACK_1};
    cursor: pointer;

    &:hover {
      background-color: ${COLOR.HOVER_REPEAT_BOOKING};
    }
  }

  .confirm-button {
    width: 170px;
    height: auto;
    padding: 10px 12px;
    border-radius: 4px;
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.XS};
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT ?? COLOR.BLACK_1};
    box-shadow: none;
    cursor: pointer;
  }
`
